import api from '../../../../../api/client';
import { ENROLLMENT } from '../../../../../api/endpoints';
import { handleApiError, handleApiResponse } from '../../../../../api/handlers';

export async function getEnrollments(params = {}) {
  try {
    const response = await api.get(ENROLLMENT.INDEX, {
      params,
    });
    const data = handleApiResponse(response);
    return data;
  } catch (error) {
    throw handleApiError(error);
  }
}
export async function enrollmentAction(payload = {}) {
  try {
    const response = await api.post(ENROLLMENT.ACTION, payload);
    const data = handleApiResponse(response);

    return data;
  } catch (error) {
    throw handleApiError(error);
  }
}
